import React, { PureComponent } from "react";
import ReactDOM from "react-dom";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import { connect } from "react-redux";
import { Jumbotron, Modal, ModalHeader, ModalBody } from "reactstrap";
import moment from "moment";
import userActions from "../../_actions/userActions";
import { actionScripts } from "../../_helpers/actionScripts";
import UpdateNotes from "../updateNotes/UpdateNotes";
import ProjList from "../projects/projList/projList.jsx";

class Home extends PureComponent {
  state = {
    sortColumn: { path: "fullEA", order: "asc" },
    isReleaseNotesModalOpen: false,
  };

  componentDidMount() {
    const currentVersion = this.props.appSettings?.version;
    if (currentVersion) this._checkVersionModal(currentVersion);
  }

  componentDidUpdate(prevProps) {
    const prevVersion = prevProps.appSettings?.version;
    const currentVersion = this.props.appSettings?.version;
    if (!prevVersion && currentVersion) this._checkVersionModal(currentVersion);
  }

  _checkVersionModal(currentVersion) {
    const lastSeenVersion = localStorage.getItem("prodms_lastSeenVersion");
    if (currentVersion !== lastSeenVersion) {
      this.setState({ isReleaseNotesModalOpen: true });
      localStorage.setItem("prodms_lastSeenVersion", currentVersion);
    }
  }

  handleClick_login = async (e) => {
    e.preventDefault();
    const { appSettings, dispatch, toggleLoginModal, initSession } = this.props;

    // TODO: Include CT_UAT here
    if (["CT", "Local_SSO"].includes(appSettings.environmentContext)) {
      await dispatch(userActions.getAuth());
      if (this.props.authentication.loggedIn) initSession();
    } else toggleLoginModal();
  };

  handleClick_logout = (e) => {
    e.preventDefault();
    this.props.toggleAlert_logoutConfirm();
  };

  toggleReleaseNotesModal = () => {
    this.setState(prevState => ({
      isReleaseNotesModalOpen: !prevState.isReleaseNotesModalOpen,
    }));
  };

  renderLoginStatus = () => {
    const { authentication, appSettings } = this.props;
    if (authentication.loggedIn) {
      return (
        <p className="lead my-auto">
          Welcome! You are logged in as <code>{authentication.user.username}</code>.
          <button
            type="button"
            className="btn btn-secondary btn-sm my-auto mx-2"
            disabled
          >
            View Profile
          </button>
          {!["CT", "CT_UAT"].includes(appSettings.environmentContext) && (
            <button
              type="button"
              className="btn btn-danger btn-sm my-auto"
              onClick={this.handleClick_logout}
            >
              Log Out
            </button>
          )}
        </p>
      );
    } else {
      return (
        <p className="lead my-auto">
          You are currently not logged in. Please
          <button
            type="button"
            className="btn btn-primary btn-sm mx-2"
            onClick={this.handleClick_login}
          >
            Log In
          </button>
        </p>
      );
    }
  };

  renderVersionInfo = () => {
    const { appSettings } = this.props;
    const version = appSettings?.version || "(N/A)";

    return (
      <p className="text-muted mb-0">
          Version {version} |{" "}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              this.toggleReleaseNotesModal();
            }}
          >
            View Release Notes
          </a>
          {" "} | Last Updated on 10/12/26
      </p>
    );
  };

  updateNotesContainer = document.getElementById("updateNotesContainer");

  render() {
    const { authentication, updateNotes , openTabs} = this.props;
    const { isReleaseNotesModalOpen } = this.state;

    return (
      <React.Fragment>
        <Jumbotron className="m-2 p-4">
          <div className="d-flex align-items-baseline">
            <h2 className="display-5 mb-0 mr-3">Caltrans ProDMS</h2>
            {authentication.loggedIn && this.renderVersionInfo()}
          </div>
          <p>{moment().format("MMMM D, YYYY (dddd)")}</p>
          <hr className="my-2" />
          {this.renderLoginStatus()}
        </Jumbotron>
        <ProjList tab={openTabs[0]} />

        {/* Release Notes Modal */}
        <Modal
          isOpen={isReleaseNotesModalOpen}
          toggle={this.toggleReleaseNotesModal}
          size="lg"
        >
          <ModalHeader toggle={this.toggleReleaseNotesModal}>
            Release Notes
          </ModalHeader>
          <ModalBody>
            <UpdateNotes />
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  appSettings: state.appSettings,
  authentication: state.authentication,
  updateNotes: state.updateNotes,
  openTabs: state.mainTabs.openTabs,
});

export default connect(mapStateToProps)(Home);
